import { useState } from 'react';
import {
  Platform,
  UIManager,
  LayoutAnimation,
  Linking,
} from 'react-native';
import { CaretUp, CaretDown } from '../../sharedComponents/Icons';
import {
  ThemedPressable,
  ThemedText,
  ThemedView,
  themeColorSet,
} from '@app/theme';

if (
  Platform.OS === 'android' &&
  UIManager.setLayoutAnimationEnabledExperimental
) {
  UIManager.setLayoutAnimationEnabledExperimental(true);
}

interface AccordionProps {
  id: string;
  title: string;
  description?: string;
  link?: string;
}

const Accordion = ({ id, title, description, link }: AccordionProps) => {
  const [expanded, setExpanded] = useState(false);

  const toggle = () => {
    LayoutAnimation.configureNext(
      LayoutAnimation.create(
        260,
        LayoutAnimation.Types.easeInEaseOut,
        LayoutAnimation.Properties.opacity
      )
    );

    setExpanded(prev => !prev);
  };

  return (
    <ThemedView
     bg="bg-surface-primary" key={id}>
      <ThemedPressable
        flexDirection="row"
        justifyContent="space-between"
        alignItems="center"
        onPress={toggle}
      >
        <ThemedText variant="b3s" color="text-primary">
          {title}
        </ThemedText>

        {expanded ? (
          <CaretUp
            size={14}
            color={themeColorSet['icon-primary']}
            weight="bold"
          />
        ) : (
          <CaretDown
            size={14}
            color={themeColorSet['icon-primary']}
            weight="bold"
          />
        )}
      </ThemedPressable>

      {expanded && (
        <ThemedView 
         mt="sm">
          <ThemedText variant="b4r" color="text-secondary">
            {description?.replace('${tenure}', '12')}
          </ThemedText>

          {link && (
            <ThemedPressable onPress={() => Linking.openURL(link)}>
              <ThemedText
                variant="b3b"
                color="text-action-primary"
                mt="xs"
                textDecorationLine="underline"
              >
                click here to raise data deletion request
              </ThemedText>
            </ThemedPressable>
          )}
        </ThemedView>
      )}

      <ThemedView height={1} bg="border-secondary" marginVertical="lg" />
    </ThemedView>
  );
};

export default Accordion;
